import React, {useEffect, useRef, useState} from 'react'
import { Box, Button, Skeleton, Typography, Tooltip } from "@mui/material";
import { Toast } from "primereact/toast";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useSelector, useDispatch} from 'react-redux';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import IconButton from '@mui/material/IconButton';
import { Menu as PrimeMenu } from 'primereact/menu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomAxios from '../utils/CustomAxios';
import { useGetCategories,useGetInventory } from '../Components/globalFunctions';
import { updateEdit, updateCategoryDetails, updateModal } from '../Redux/category-redux';
import { blobSrc } from '../utils/blobUrl';
import { describeTiming, fetchAllHubTimings } from '../utils/categoryTimings';


export function Category_table() {

    const toast  = useRef(null)
    const category = useSelector(state => state.category.category)
    const [updatedcategory, setUpdatedCategory] = useState()
    // Trading hours are keyed by category name in their own table, so the list
    // is fetched once and matched by name rather than joined server-side.
    const [timings, setTimings] = useState({})

    // Re-read on every category refresh, not just on mount: saving the modal
    // calls getCategory(), and a column still showing the old hours after an
    // edit reads as an edit that did not save.
    useEffect(() => {
        let cancelled = false
        fetchAllHubTimings()
            .then(rows => { if (!cancelled) setTimings(rows) })
            .catch(err => console.error('Could not load category timings:', err))
        return () => { cancelled = true }
    }, [category])
    const categoryLoading  = useSelector(state => state.category.loading);
    const search = useSelector(state => state.category.searchCategory)
    const inventory = useSelector(state => state.inventory.inventory)
    const dispatch = useDispatch();
    const menuRefs = useRef([]);
    const getCategory = useGetCategories()
    const getInventory = useGetInventory()
    const user_role = localStorage.getItem('role');

    useEffect(()=>{
        const newcategory = category.map(obj2=>{
            const matchedValues =[]
            obj2.invetory_list.forEach(key=>{
            const match = inventory.find(obj1=>obj1.value===key)
            if (match){
                matchedValues.push(match.name)
            }
        })
        return {...obj2, inventory_name:matchedValues}
        })
        
        // Apply hub-based filtering for super admin
        let filteredCategories = newcategory;
        if (user_role === 'super_admin') {
            const selectedHubRaw = localStorage.getItem('selected_hub');
            let selectedHub;
            try {
                const parsedHub = JSON.parse(selectedHubRaw || '[]');
                selectedHub = Array.isArray(parsedHub) && parsedHub.length > 0 ? parsedHub[0] : parsedHub;
            } catch (error) {
                selectedHub = selectedHubRaw;
            }
            
            // If a specific hub is selected, filter categories by that hub
            if (selectedHub && selectedHub !== 'all' && selectedHub !== '[]') {
                filteredCategories = newcategory.filter(cat => 
                    cat.invetory_list && cat.invetory_list.includes(selectedHub)
                );
            }
        }
        
        console.log(filteredCategories)
        setUpdatedCategory(filteredCategories)
    }, [inventory, category, user_role])
    const handleOpen = (row) => {
        console.log(row)
        dispatch(updateEdit(true))
        dispatch(updateCategoryDetails(row));
        dispatch(updateModal(true))  
    };

    const confirmDelete = (item) => {
        console.log(item)
         confirmDialog({
              message: (
                <Box sx={{ display: "flex", gap: "10px",flexDirection:"column" }}>
                  <Box sx={{ display: "flex", gap: "5px",alignItems:"center" }}>
                    {item.category_image.map((img) => (<Box component='img' src={blobSrc(img)} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
                    <Box >{item.category_name}</Box>
                  </Box>
               <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>Do you want to {item.is_active == true ? 'Deactivate' : 'Activate'} this Category{item.is_active == true&&', There are some products which are conneected with this category'} </Typography>
                </Box>
              ),
              header: 'Delete Confirmation',
              defaultFocus: 'reject',
              acceptClassName: 'p-button-danger',
              accept: () => accept(item.id),
            });
    }

      const accept = async (id) => {
        console.log(id)
        const response = await CustomAxios.delete(`category_update/${id}/`, {
          
        }).then(res => {
        getCategory()
        getInventory()
          toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
        }).catch(err => { console.log(err) });
      }
      console.log(category)
      console.log(inventory)
      console.log(updatedcategory)
  return (
    <Box>
        <Toast ref={toast} />
        <Typography sx={{fontSize: "16px", fontWeight: "700", lineHeight: "24px"}}>Category List</Typography>
         <ConfirmDialog />
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Category Images</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Category Name</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Inventory List</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Order Timings</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
  {updatedcategory?.length > 0
    ? updatedcategory ?.filter((item) => {
            console.log(item)
          if (!item.category_name) return false; // Exclude items without a description
          return search !== ""
            ? item?.category_name.toLowerCase().includes(search.toLowerCase()) // Case-insensitive search match
            : true; 
        })
        .map((item, ind) => {
          if (!menuRefs.current[ind]) {
            menuRefs.current[ind] = React.createRef();
          }
          return (
            <>
              {
                <TableRow key={1}>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {ind + 1}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item?.category_image?.map((img) => (
                      <Box
                        component="img"
                        src={blobSrc(img)}
                        sx={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "8px",
                          marginRight: "10px",
                        }}
                      ></Box>
                    ))}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.category_name}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.inventory_name.join(", ")}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      backgroundColor: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {describeTiming(timings[String(item.category_name || "").trim().toLowerCase()])}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.is_active == false ? <Box sx={{ width: "120px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }}><Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red", textAlign: "center", textTransform: "uppercase", width: "88px" }}> Inactive</Typography></Box> : <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} ><Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>Active</Typography></Box>}</TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <PrimeMenu
                      model={[
                        {
                          label: "Edit",
                          command: () => handleOpen(item),
                        },
                        {
                          label: "Activate / Deactivate",
                          command: () => confirmDelete(item),
                        },
                      ]}
                      popup
                      ref={menuRefs.current[ind]} // Use the indexed ref
                      style={{ marginLeft: "", marginTop: "-10px" }}
                      className="custom-menu"
                    />
                    <Tooltip title="View inventory batches" arrow>
                      <IconButton
                        sx={{ textTransform: "none" }}
                        onClick={(event) =>
                          menuRefs.current[ind]?.current?.toggle(event)
                        } // Use the indexed ref to toggle menu
                      >
                        <MoreHorizSharpIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              }
            </>
          );
        })
    : (
      <TableRow>
        {categoryLoading ? (
          <TableCell
            sx={{
              textAlign: "center",
              textTransform: "capitalize",
              backgroundColor: "white",
              height: "200px",
              fontWeight: "700",
            }}
            colSpan={7}
          >
            <Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
            </Box>
          </TableCell>
        ) : (
          <TableCell
            sx={{
              textAlign: "center",
              textTransform: "capitalize",
              backgroundColor: "white",
              height: "200px",
              fontWeight: "700",
            }}
            colSpan={7}
          >
            No Category Details Available
          </TableCell>
        )}
      </TableRow>
    )}
</TableBody>

            </Table>
        </TableContainer>
    </Box>
  )
}

